import { Collection } from '../../models/Collection';

const _IsUndefined = (input: any) => input === void 0 || typeof input === 'undefined';

const _IsNull = (input: any) => input === null;

const _IsNullOrUndefined = (input: any) => _IsUndefined(input) || _IsNull(input);

const _IsFunction = (input: any) => !_IsNullOrUndefined(input) && typeof input === 'function';

const _IsPromise = (input: any) => !_IsNullOrUndefined(input) && _IsFunction(input.then);

const _IsArray = (input: any) =>
  !_IsNullOrUndefined(input) && Array.isArray(input) && !_IsNullOrUndefined(input.length);

const _IsString = (input: any) => !_IsNullOrUndefined(input) && typeof input === 'string';

const _IsCollection = (input: any) => !_IsNullOrUndefined(input) && input instanceof Collection;

const _IsEmptyCollection = (input: any) =>
  _IsCollection(input) && (input as Collection<any>).list().length === 0;

const _IsEmptyString = (input: any) => _IsString(input) && input.trim() === '';

const _IsObject = (input: any) => !_IsNullOrUndefined(input) && input.constructor === Object;

const _IsEmptyObject = (input: any) => _IsObject(input) && Object.keys(input).length === 0;

const _IsEmptyArray = (input: any) => _IsArray(input) && input.length === 0;

const _IsStringEmptyNullOrUndefined = (input: any) =>
  _IsEmptyString(input) || _IsNullOrUndefined(input);

const _IsObjectEmptyNullOrUndefined = (input: any) =>
  _IsEmptyObject(input) || _IsNullOrUndefined(input);

const _IsWindowDefined = () => typeof window !== 'undefined';

const _IsArrayEmptyNullOrUndefined = (input: any) =>
  _IsEmptyArray(input) || _IsNullOrUndefined(input);

const _IsCollectionEmptyNullOrUndefined = (input: any) =>
  _IsEmptyCollection(input) || _IsNullOrUndefined(input);

export const Controls = {
  IsNull: _IsNull,
  IsUndefined: _IsUndefined,
  IsNullOrUndefined: _IsNullOrUndefined,
  IsFunction: _IsFunction,
  IsPromise: _IsPromise,
  IsArray: _IsArray,
  IsObject: _IsObject,
  IsString: _IsString,
  IsCollection: _IsCollection,
  IsStringEmptyNullOrUndefined: _IsStringEmptyNullOrUndefined,
  IsObjectEmptyNullOrUndefined: _IsObjectEmptyNullOrUndefined,
  IsArrayEmptyNullOrUndefined: _IsArrayEmptyNullOrUndefined,
  IsCollectionEmptyNullOrUndefined: _IsCollectionEmptyNullOrUndefined,
  IsWindowDefined: _IsWindowDefined,
};
